module.exports = __webpack_public_path__ + "static/img/95073C_1_2_C_20220309_LC.7bcc6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95073C_1_2_C_20220309_LC.png
// module id = i6+N
// module chunks = 0